__webpack_require__.p = "/Memory-Card/";